import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { contentHeaders,APIURL,JsonURL } from '../common/headers';
import { IUsers } from '../database';
@Injectable()
export class UsersService {
    private _CountryUrl = JsonURL+'data/countries.json';
    private _StateUrl = JsonURL+'data/countries/';
    private _getUrserUrl = APIURL+'Users/users';
    private _isActivelUrl = APIURL+'Users/userVerify';
    private _isBlocklUrl = APIURL+'Users/userBlock';
    private _deleteUrl = APIURL+'Users/deleteUser';
     private _addUrl = APIURL+'Users/UpdateUser';
     private _getUrserBySearchUrl=APIURL+'Users/UrserBySearch';
     private _getUrserById=APIURL+'Users/UrserById';
     private _getDashboardById=APIURL+'Users/getDashboard';
     private _settingUrl = APIURL+'Users/setSetting';
     private _cashOutUrl = APIURL+'Users/setCashOut';
    private currentUser :IUsers ; 
    constructor(private _http: Http) { 
           this.currentUser = JSON.parse(localStorage.getItem('UserInfo'));
    }
    getAdminDashboardData():any{
          return this._http.post(this._getDashboardById,null)
                            .map((response: Response) => response.json().data)
    }
    getDashboardData(UserId,userType):any{
           let formData:FormData = new FormData();
         formData.append('UserId', UserId);
         formData.append('userType', userType);
          return this._http.post(this._getDashboardById,formData)
                            .map((response: Response) => response.json().data)
    }
    getUsersByTextAndSize(text,size):any{
           let formData:FormData = new FormData();
         formData.append('text', text);
         formData.append('size', size);
          return this._http.post(this._getUrserBySearchUrl,formData )
                            .map((response: Response) => response.json().data)
    }
    getUsersById(userId){
         let formData:FormData = new FormData();
         formData.append('userId', userId);
          return this._http.post(this._getUrserById,formData )
                            .map((response: Response) => response.json().data)
    }
    getCountry(): any  {
        return this._http.post(this._CountryUrl,[])
            .map((response: Response) => response.json())
            .catch(this.handleError);
    }
    setSmartstudy_provision(Smartstudy_provision){
        let formData:FormData = new FormData();
        formData.append('value', Smartstudy_provision);
        formData.append('SettingId', "1");
     return this._http.post(this._settingUrl,formData )
           .map((response: Response) => response.json())
           .catch(this.handleError);
    }
    setMinimumPayout(MinimumPayout){
        let formData:FormData = new FormData();
        formData.append('value', MinimumPayout);
        formData.append('SettingId', "2");
     return this._http.post(this._settingUrl,formData )
           .map((response: Response) => response.json())
           .catch(this.handleError);
    }
    getStateByCountry(con:string): any  {
        return this._http.post(this._StateUrl+con+".json",[])
            .map((response: Response) => response.json())
            .catch(this.handleError);
    }
    isUserBlock(UserId:string,type): any{
         let formData:FormData = new FormData();
         formData.append('UserId', UserId);
          formData.append('type', type);
        return this._http.post(this._isBlocklUrl,formData )
                            .map((response: Response) => response.json())
                            .catch(this.handleError);
    }
    isUserActive(UserId:string,type): any{
         let formData:FormData = new FormData();
         formData.append('UserId', UserId);
          formData.append('type', type);
        return this._http.post(this._isActivelUrl,formData )
                            .map((response: Response) => response.json())
                            .catch(this.handleError);
    }
    add(form:any,UserPhoto,UserIDProof):any{
          let formData:FormData = new FormData();
         formData.append('firstName', form.firstName);
         formData.append('lastName', form.lastName);
          formData.append('qualification', form.qualification);
          
          formData.append('UserAddress', form.UserAddress);
          formData.append('bank_Name', form.bank_Name);
          //formData.append('IFCE', form.IFCE);
          formData.append('IBAN', form.IBAN);
           formData.append('BIC', form.BIC);
           formData.append('UserId', form.UserId); 
           formData.append('Taxnumber', form.Taxnumber); 
           formData.append('TaxOffice', form.TaxOffice); 
         if(UserPhoto!=null){
              formData.append('UserPhoto', UserPhoto, UserPhoto.name);
          }
          if(UserIDProof!=null){
              formData.append('UserIDProof', UserIDProof, UserIDProof.name);
          }
      return this._http.post(this._addUrl,formData )
            .map((response: Response) => response.json())
            .catch(this.handleError);
    }
    edit(form:any):any{
          let formData:FormData = new FormData();
         formData.append('firstName', form.firstName);
         formData.append('lastName', form.lastName);
          formData.append('qualification', form.qualification);
          
          formData.append('UserAddress', form.UserAddress);
          formData.append('bank_Name', form.bank_Name);
          formData.append('IFCE', form.IFCE);
          formData.append('IBAN', form.IBAN);
           formData.append('BIC', form.BIC);
           formData.append('UserId', form.UserId);
      return this._http.post(this._addUrl,formData )
            .map((response: Response) => response.json())
            .catch(this.handleError);
    }
    getUsers(): any{
        let formData:FormData = new FormData();
        formData.append('firstName', "");
        return this._http.post(this._getUrserUrl,formData )
                            .map((response: Response) => response.json().data)
         
    }
    delete(userId): any{
           let formData:FormData = new FormData();
         formData.append('UserId', userId);
        return this._http.post(this._deleteUrl,formData )
                            .map((response: Response) => response.json().data)
         
    }
    setCashOut(){
        let formData:FormData = new FormData();
        formData.append('UserId', this.currentUser.UserId+"");
     return this._http.post(this._cashOutUrl,formData )
           .map((response: Response) => response.json())
           .catch(this.handleError);
    }
     private handleError(error: Response) {
        return Observable.throw(error.json().error || 'Server error');
    }
}


// WEBPACK FOOTER //
// ./src/app/service/users.service.ts